import {GetServicesDentalGuide} from 'domain/usecases';
import {RemoteGetServicesDentalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetServicesDentalGuide = (): GetServicesDentalGuide =>
	new RemoteGetServicesDentalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.odontoGuideServices),
		makeAuthorizeHttpClientDecorator(),
	);
